module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title,
      "showPreview": false,
      "disableOk": false
    }
  }, [_c('div', {
    staticClass: "content",
    class: [_vm.showPreview ? 'is-hidden' : ''],
    attrs: {
      "id": "modal-edit-content"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Video "), _c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v("(1920x1080px .mp4)")])]), _vm._v(" "), (_vm.coachVideo) ? _c('figure', {
    staticClass: "image fake-dropzone-video"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.screensaverLocation + _vm.coachVideo,
      "type": "video/mp4"
    }
  }), _vm._v("\n            Your browser does not support the video tag.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": _vm.showDropzone
    }
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (!_vm.coachVideo) ? _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "coachVideoDz",
      "url": _vm.dropzoneUploadUrl,
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": ".mp4"
    },
    on: {
      "vdropzone-success": _vm.successUploadVideo,
      "vdropzone-removedfile": _vm.removeVideo
    }
  })], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1bffd22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachScreensaverModal.vue
// module id = 352
// module chunks = 1